export default __webpack_public_path__ + "static/media/side2.d9d7cd47.jpeg";